import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

export function IdentifyPostHogUser({ children }) {
	const isReady = useIdentifyPostHogUser();
	return isReady ? children : null;
}

export default IdentifyPostHogUser;

function useIdentifyPostHogUser() {
	const [searchParams] = useSearchParams();
	const [isReady, setIsReady] = useState(false);

	useEffect(() => {
		const distinctIdFromUrl = searchParams.get('distinctId');

		// Validate the distinct ID: ensure it exists, is a string, and isn't just whitespace.
		if (
			distinctIdFromUrl &&
			typeof distinctIdFromUrl === 'string' &&
			distinctIdFromUrl.trim() !== ''
		) {
			const storedDistinctId = localStorage.getItem('marketingDistinctId');
			if (!storedDistinctId) {
				localStorage.setItem('marketingDistinctId', distinctIdFromUrl);
			}
		}
		setIsReady(true);
	}, [searchParams]);

	return isReady;
}
